import type { LevelConfig } from '../types'
import { padRow } from '../utils'

export const inglenookSidings: LevelConfig = {
  grid: [
    padRow(
      [
        { track: 'WE', exit: 'W', vehicle: { type: 'locomotive', direction: -1 } },
        'WE',
        'WE',
        ['WE', 'SW'],
        { track: 'WE', vehicle: { type: 'wagon', color: 'red', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'gold', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'lawngreen', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'aqua', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'blue', direction: -1 } },
        'E',
      ],
      'prepend',
    ),
    padRow(['NS'], 'prepend', false, 13),
    padRow(
      [
        ['NE', 'NS'],
        { track: 'WE', vehicle: { type: 'wagon', color: 'forestgreen', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'darkorange', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'purple', direction: -1 } },
        'E',
      ],
      'prepend',
      false,
      13,
    ),
    padRow(['NS'], 'prepend', false, 13),
    padRow(['NE', 'WE', 'WE', 'WE', 'E'], 'prepend', false, 13),
  ],
  goal: {
    generator() {
      return ['blue', 'darkorange', 'gold', 'lawngreen', 'red', 'forestgreen', 'aqua', 'purple']
        .sort(() => Math.random() - 0.5)
        .slice(0, Math.floor(Math.random() * 3) + 3)
    },
  },
}

export const emptyInglenookSidings: LevelConfig = {
  grid: [
    padRow(
      [
        { track: 'WE', exit: 'W', vehicle: { type: 'locomotive', direction: -1 } },
        'WE',
        'WE',
        ['WE', 'SW'],
        'WE',
        'WE',
        'WE',
        'WE',
        'WE',
        'E',
      ],
      'prepend',
    ),
    padRow(['NS'], 'prepend', false, 13),
    padRow([['NE', 'NS'], 'WE', 'WE', 'WE', 'E'], 'prepend', false, 13),
    padRow(['NS'], 'prepend', false, 13),
    padRow(['NE', 'WE', 'WE', 'WE', 'E'], 'prepend', false, 13),
  ],
  goal: { sequence: ['PLACEHOLDER'] },
}

export const loopInglenookSidings: LevelConfig = {
  grid: [
    padRow(['W', 'WE', 'WE', 'SW'], 'prepend', false, 8),
    padRow(
      [
        { track: 'WE', exit: 'W', vehicle: 'wagon' },
        { track: ['WE', 'NE'], vehicle: { type: 'locomotive', direction: -1 } },
        'WE',
        ['WE', 'SW'],
        { track: 'WE', vehicle: { type: 'wagon', color: 'red', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'gold', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'lawngreen', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'aqua', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'blue', direction: -1 } },
        'E',
      ],
      'prepend',
    ),
    padRow(['NS'], 'prepend', false, 13),
    padRow(
      [
        ['NE', 'NS'],
        { track: 'WE', vehicle: { type: 'wagon', color: 'forestgreen', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'darkorange', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'purple', direction: -1 } },
        'E',
      ],
      'prepend',
      false,
      13,
    ),
    padRow(['NS'], 'prepend', false, 13),
    padRow(['NE', 'WE', 'WE', 'WE', 'E'], 'prepend', false, 13),
  ],
  goal: {
    generator() {
      return ['blue', 'darkorange', 'gold', 'lawngreen', 'red', 'forestgreen', 'aqua', 'purple']
        .sort(() => Math.random() - 0.5)
        .slice(0, Math.floor(Math.random() * 3) + 3)
    },
  },
}
